import Play from './Play';
import PlayArrow from './PlayArrow';
import Search from './Search';

export default {
  Play,
  PlayArrow,
  Search,
};



// WEBPACK FOOTER //
// ./icons/index.js